import React, { useContext } from "react";
import { getAllConfigurationProducts } from "../utils/getAllConfigurationEntities";
import ConfiguratorContext from "./ConfiguratorContext";
import { FormattedMessage } from "react-intl";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/solid";
import AuthenticationService from "../services/AuthenticationService";
export const linkColumns = ["link_scheda_tecnica", "link_video"];

const ConfiguratorSurveySummaryStepProductsLinks = (
  {
    role
  }
) => {
  const context = useContext(ConfiguratorContext);
  const userData = AuthenticationService.getUserData();

  // Fix duplicates with same link_scheda_tecnica and prod_stat_des
  const removeDuplicates = (arr) => {
    return  arr.filter((product, index, self) =>
        index === self.findIndex(
          (t) =>
            t.link_scheda_tecnica === product.link_scheda_tecnica &&
            t.prod_stat_des === product.prod_stat_des
        )
    );
  }

  const products = removeDuplicates(getAllConfigurationProducts(context, role));

  if (!products.length) {
    return null;
  }

  return (
    <div className="flex w-full flex-col mt-8">
      {linkColumns
        .filter((key) => {
          return products.some((p) => p?.[key]);
        })
        .map((key) => (
          <div
            key={key}
            className="flex flex-col w-full border-b border-black mb-4"
          >
            <h3 className="text-2xl mb-4">
              <FormattedMessage id={key} />
            </h3>
            {products
              .filter((p) => p[key])
              .map((p) => (
                <a
                  href={p[key]}
                  target="_blank"
                  key={p.art_cod  || p.code}
                  className="mb-4"
                  rel="noreferrer"
                >
                  <div className="w-full flex justify-between">
                    <div className="flex items-center">
                      <ArrowTopRightOnSquareIcon
                        className={`w-6 h-6 mr-2 text-${userData.business}-400`}
                      />

                      <p className="text-black underline">{p.prod_stat_des || p?.des_prod_comm?.toUpperCase()}</p>
                      {/* <p>{p[key]}</p> */}
                    </div>
                  </div>
                </a>
              ))}
          </div>
        ))}
    </div>
  );
};

export default ConfiguratorSurveySummaryStepProductsLinks;
